<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=true><p slot="title">{{params.id ? '编辑': '新增'}}优惠券</p></sub-ibox-title>
		<div class="box content" >
			<section class="phone-show">
				<h3>优惠券</h3>
				<div class="coupon-cont" :class="params.color">
					<div class="logo-cont"><img :src="userInfo.logo_url || '../../../../public/logo.png'" /></div>
					<div class="coupon-dtl">
						<h4 class="text-center">{{userInfo.username || '请完善商户名称'}}</h4>
						<div class="text-center">{{params.title|| '优惠券名称'}}</div>
						<h5 class="fx-align"><p><span>￥</span>{{params.reduce_cost|| 'XX'}}</p></h5>
						<div class="condition m-t-10"><span>使用条件：</span>消费满{{params.least_cost || 'xx'}}元可用</div>
						<div class="condition m-t-5"><span>可否共享：</span>{{params.is_shared == 'Y' ?'可与其他优惠活动共享' : '不与其他优惠活动共享'}}</div>
						<div class="time" v-if="picker_date[0] != null && picker_date[1] != null"><span>可用时间：</span>{{picker_date[0], "YYYY.MM.DD" | momentFmt}}-{{picker_date[1], "YYYY.MM.DD" | momentFmt}}</div>
						<div class="time" v-else><span>可用时间：</span>xxxx.xx.xx-xxxx.xx.xx</div>
						<div class="box explain"><div>使用说明：</div><p class="box-flex c-f-s">{{params.description||'这里是使用说明'}}</p></div>
						<ul>
							<li class="fx fx-x-between fx-y-center"><p>适用门店</p><p class="icon-back"></p></li>
						</ul>
					</div>
				</div>
			</section>
			<section class="menu-edit b-r-5 box-flex">
				<div class="w400">
					<z-input title="优惠券名称" maxlength="9" isMust = true placeholder="用优惠亮点，吸引顾客领取" v-model.trim="params.title"></z-input>
					<div class="box m-t-5">
						<p class="w120 m-r-5"></p>
						<p class="pic-tips">Tips：字数上限为9个汉字,建议填写优惠券“减免金额”</p>
					</div>
				</div>
				<div class="w400 m-t-20">
					<z-input type="number" title="发放总量" isMust = true placeholder="输入发放数量" v-model.number="params.quantity"></z-input>
					<div class="box m-t-5">
						<p class="w120 m-r-5"></p>
						<p class="pic-tips">Tips：优惠券发放总量，上限为100000000张</p>
					</div>
				</div>
				<div class="w400 m-t-20">
					<z-input type="number" title="优惠券面值" isMust = true placeholder="设置优惠券面值" v-model.number="params.reduce_cost"></z-input>
					<div class="box m-t-5">
						<p class="w120 m-r-5"></p>
						<p class="pic-tips">Tips：优惠面值只能是大于0.01的数字</p>
					</div>
				</div>
				<div class="box m-t-20">
					<div class="w120 m-r-5 m-t-5 fx"><i class="ask">*</i><span class="fx-fill">卡券封面</span></div>
					<div class="card-bg box-flex">
						<ul class="fx fx-wrap w400">
							<li class="color010" :class="{'active': params.color == 'Color010'}" @click="handleChooseColor('Color010')"></li>
							<li class="color020" :class="{'active': params.color == 'Color020'}" @click="handleChooseColor('Color020')"></li>
							<li class="color030" :class="{'active': params.color == 'Color030'}" @click="handleChooseColor('Color030')"></li>
							<li class="color040" :class="{'active': params.color == 'Color040'}" @click="handleChooseColor('Color040')"></li>
							<li class="color050" :class="{'active': params.color == 'Color050'}" @click="handleChooseColor('Color050')"></li>
							<li class="color060" :class="{'active': params.color == 'Color060'}" @click="handleChooseColor('Color060')"></li>
							<li class="color070" :class="{'active': params.color == 'Color070'}" @click="handleChooseColor('Color070')"></li>
							<li class="color080" :class="{'active': params.color == 'Color080'}" @click="handleChooseColor('Color080')"></li>
							<li class="color081" :class="{'active': params.color == 'Color081'}" @click="handleChooseColor('Color081')"></li>
							<li class="color082" :class="{'active': params.color == 'Color082'}" @click="handleChooseColor('Color082')"></li>
							<li class="color090" :class="{'active': params.color == 'Color090'}" @click="handleChooseColor('Color090')"></li>
							<li class="color100" :class="{'active': params.color == 'Color100'}" @click="handleChooseColor('Color100')"></li>
							<li class="color101" :class="{'active': params.color == 'Color101'}" @click="handleChooseColor('Color101')"></li>
							<li class="color102" :class="{'active': params.color == 'Color102'}" @click="handleChooseColor('Color102')"></li>
						</ul>
					</div>
				</div>
				<div class="fx fx-y-center m-t-20">
					<p class="w120 fx"><i class="ask">*</i><span class="fx-fill">有效期</span></p>
					<div class="box-flex m-l-5">
						<el-date-picker
					      v-model="picker_date"
					      type="daterange"
					      placeholder="选择时间范围"
					      >
					    </el-date-picker>
					</div>
				</div>
				<div class="fx fx-y-center m-t-20 w400">
					<p class="fx w120"><i class="ask">*</i><span class="fx-fill">领券限制</span></p>
					<div class="fx fx-y-center w120 m-l-5"><input type="number" class="input m-r-10"  v-model.number="params.get_limit"/>张</div>
				</div>
				<div class="box m-t-10">
						<p class="fx w120 m-l-5"></p>
				        <p class="pic-tips">Tips：每个用户领券上限，如不填，则默认为1</p>
				    </div>
				<div class="fx fx-y-center m-t-20">
					<p class="fx w120 m-r-5"><i class="ask">*</i><span class="fx-fill">使用条件</span></p>
					<div class="w400">
						<!--<z-input type="number" title="最低消费" placeholder="最低消费多少金额可用" v-model="params.least_cost"></z-input>-->
						<div class="fx fx-y-center m-t-20 w400">
							<p class="fx "><span class="fx-fill">最低消费：</span></p>
							<div class="fx fx-y-center w200"><input type="number" class="input"  v-model.number="params.least_cost"/></div>
						</div>
						<div class="box m-t-10">
					        <p class="pic-tips">Tips：消费金额大于0且只能到百分位！</p>
					    </div>
						<div class="fx fx-y-center m-t-20">
							<p class="">优惠同享：</p>
							<z-select :options="is_shared_arr" class="w200" v-model.trim="params.is_shared"></z-select>
						</div>
						
					</div>
				</div>
				<div class="fx fx-y-center m-t-20">
							<p class="m-r-10 w120"><i class="ask">*</i><span class="fx-fill">适用门店</span></p>
							<div class="box-flex">
								<el-transfer :titles = "['全部门店','已选门店']" v-model="params.shop_list" :data="transfer_data"></el-transfer>
							</div>
						</div>
				<!--<div class="w400 m-t-20"><z-input type="tel" title="客服手机号" placeholder="请填写客服手机号" v-model="params.service_phone" maxlength = 11></z-input></div>-->
				<div class="m-t-20"><z-input title="使用说明" type="textarea" v-model.trim="params.description" isMust = true placeholder="请填写使用本优惠券的注意事项"></z-input></div>
				<div class="m-t-20 box">
					<p class="w120 m-r-5"></p>
					<a class="z-btn z-btn-primary b-r-3" @click="handleValidate">保存</a>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
	import { mapState, mapActions } from 'vuex'
	export default {
		name: 'ConpinEdit',
		data() {
			return {
				transfer_data : [],
				picker_date: [null,null],
				params: {
					id:null, //卡券id
					title: '',//卡券名
					color: 'Color010',//券颜色
					description: '',//卡券使用说明
					quantity: '',//卡券库存的数量
					reduce_cost:'',//面值
					least_cost:'',//最低消费
					get_limit: 1,//每人可领券的数量限制
					start_time: '',//开始时间戳
					end_time: '',//结束时间戳
					is_shared: 'Y',//是否优惠共享
					shop_list: [] //门店列表
				},
				is_shared_arr:[{
					value: "Y",
					text: '可与其他优惠共享'
				},{
					value: "N",
					text: '不与其他优惠共享'
				}]
			}
		},
		computed: {
			...mapState({
				userInfo: state => state.users.userInfo
			})
		},
		async mounted() {
			const id = this.$route.query.id
			await this.handleGetShopList()
			if(this.$re_Number(id)) await this.handleCouponDetail(id)
		},
		/*
		 * 事件处理
		 */
		methods: {
			//获取门店数据
			async handleGetShopList(){
				const data = await this.getShopList({count: 1000, offset: 0})
				let arr =[]
				data.list.map((item,index)=>{
					arr.push({
						key:item.id,
						label:item.name
					})
				})
				this.transfer_data = arr
				return true
			},
			//选择背景色
			handleChooseColor(color) {
				this.params.color = color;	
			},
			//验证
			handleValidate() {
				//标题
				if (!this.params.title) {
					return this.$warning('请输入优惠券名称(灬°ω°灬)');
				}
				//发放总量
				if (!this.$re_Number(this.params.quantity)) {
					return this.$warning('输入发放总量,并且为整数哦(灬°ω°灬)');
				}
				
				//优惠面值
				if (!this.$re_twoPoint(this.params.reduce_cost)) {
					return this.$warning('输入优惠面值(灬°ω°灬)');
				}
				//有效期
				if (this.picker_date[0] ==null || this.picker_date[1] == null) {
					return this.$warning('请选择优惠券有效期(灬°ω°灬)');
				}
				//领券限制
				if (!this.$re_Number(this.params.get_limit)) {
					return this.$warning('领券限制必须是整数张哦(灬°ω°灬)');
				}
				//使用条件最低消费
				if (!this.$re_twoPoint(this.params.least_cost)) {
					return this.$warning('输入最低消费(灬°ω°灬)');
				}
				if ((this.params.shop_list).length <=0) {
					return this.$warning('请选择适用门店(灬°ω°灬)');
				}
				//使用说明
				if (!this.params.description) {
					return this.$warning('请输入卡券使用说明');
				}
				if(this.params.reduce_cost > this.params.least_cost){
					return this.$warning('最低消费金额不能小于优惠券面值金额');
				}
				this.params.start_time = this.picker_date[0]
				this.params.end_time = this.picker_date[1]
				
				this.handleSave()
			},
			async handleSave(){
				try{
					await this.couponEdit(this.params)
					this.$success('保存成功')
					this.$back()
				}catch(e){
					return this.$errorMsg(e);
				}
				
			},
			//获取优惠券详情
			async handleCouponDetail(id){
				const data = await this.couponDetail({id})
				data.least_cost = data.least_cost/100
				data.reduce_cost = data.reduce_cost/100
				this.params = data
				this.picker_date = [this.params.start_time,this.params.end_time]
			},
			...mapActions(['getShopList','couponEdit','couponDetail']),
		}
	}
</script>

<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.content{
		border-top: none;
	}
	.c-g{
		color: $color-font-tips;
	}
	.c-f-s{
		color: $color-font-sub;
	}
	.phone-show {
		width: 350px;
		height: 716px;
		background: url(../../../../assets/img/iphone.png) no-repeat;
		background-size: 100% auto;
		padding: 90px 24px 88px 24px;
		position: relative;
		h3 {
			width: 302px;
			position: absolute;
			top: 105px;
			left: 50%;
			color: #fff;
			text-align: center;
			margin-left: -151px;
			font-size: 16px;
			z-index: 3;
		}
		.coupon-cont{
			width: 100%;
			height: 100%;
			background: $color-card2;
			padding: 80px 10px 0;
			position: relative;
			&.Color010{
				background: #63b359;
			}
			&.Color020{
				background: #2c9f67;
			}
			&.Color030{
				background: #509fc9;
			}
			&.Color040{
				background: #5885cf;
			}
			&.Color050{
				background: #9062c0;
			}
			&.Color060{
				background: #d09a45;
			}
			&.Color070{
				background: #e4b138;
			}
			&.Color080{
				background: #ee903c;
			}
			&.Color081{
				background: #f08500;
			}
			&.Color082{
				background: #a9d92d;
			}
			&.Color090{
				background: #dd6549;
			}
			&.Color100{
				background: #cc463d;
			}
			&.Color101{
				background: #cf3e36;
			}
			&.Color102{
				background: #5E6671;
			}
			.logo-cont{
				width: 50px;
				height: 50px;
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid $color-border;
				position: absolute;
				left: 50%;
				top: 55px;
				margin-left: -25px;
				background: $color-white;
				img{
					width: 100%;
				}
			}
			.coupon-dtl{
				border-radius: 2px;
				padding: 30px 0 20px;
				background: $color-white;
				h4{
					color: $color-font-sub;
					padding-bottom: 10px;
				}
				h5{
					padding: 5px 0;
					font-size: 24px;
					>p{
						position: relative;
					}
					span{
						position: absolute;
						font-size: 14px;
						top: 0;
						left: -12px;
					}
				}
				.condition{
					padding-left: 20px;
					color: $color-font-sub;
					span{
						color: $color-font;
					}
				}
				.time{
					padding: 5px 0 0 20px;
					color: $color-font-sub;
					span{
						color: $color-font;
					}
				}
				.c-f-s{
					color: $color-font-sub;
				}
				.explain{
					padding: 5px 0 0 20px;
				}
				ul{
					padding: 20px;
					li{
						border-top: 1px solid $color-border;
						border-bottom: 1px solid $color-border;
						padding: 10px 0;
						.icon{
							transform: rotate(180deg);
							color: $color-font-sub;
						}
					}
				}
			}
		}
	}
	
	.integral-cont{
		h3{
			background: #eee;
			padding: 5px 10px;
		}
		.input-money{
			width: px-em(200px);
			border: 1px solid $color-border;
			padding: px-em(16px) px-em(20px);
		}
	}
	
	.menu-edit {
		border: 1px solid $color-border;
		padding: 20px;
		position: relative;
		margin-left: 30px;
		&:after,
		&:before {
			right: 100%;
			top: 15%;
			border: solid transparent;
			content: " ";
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
		}
		&:after {
			border-color: rgba($color-border, 0);
			border-right-color: #fff;
			border-width: 20px;
			margin-top: -20px;
		}
		&:before {
			border-color: rgba($color-border, 0);
			border-right-color: #ccc;
			border-width: 21px;
			margin-top: -21px;
		}
		.card-bg{
			li{
				width: 38px;
				height: 38px;
				cursor: pointer;
				transition: all 0.2s ease;
				border: 1px solid transparent;
				margin-right: 5px;
				margin-bottom: 5px;
				border-radius: 3px;
				&:nth-child(1){
					background: #63b359;
				}
				&:nth-child(2){
					background: #2c9f67;
				}
				&:nth-child(3){
					background: #509fc9;
				}
				&:nth-child(4){
					background: #5885cf;
				}
				&:nth-child(5){
					background: #9062c0;
				}
				&:nth-child(6){
					background: #d09a45;
				}
				&:nth-child(7){
					background: #e4b138;
				}
				&:nth-child(8){
					background: #ee903c;
				}
				&:nth-child(9){
					background: #f08500;
				}
				&:nth-child(10){
					background: #a9d92d;
				}
				&:nth-child(11){
					background: #dd6549;
				}
				&:nth-child(12){
					background: #cc463d;
				}
				&:nth-child(13){
					background: #cf3e36;
				}
				&:nth-child(14){
					background: #5E6671;
				}
				img{
					width: 100%;
					border-radius: 3px;
				}
				&.active{
					border-color: $color-main;
					position: relative;
					@extend .icon;
				    &:before {
				        content: "\e63f";
				        position: absolute;
				        left: 50%;
				        top: 50%;
				        margin: px-em(-26px) 0 0 px-em(-26px);
				        font-size: px-em(52px);
				        color: $color-white;
				    }
				}
				&:hover{
					border-color: $color-main;
				}
				&:active{
					transform: scale(0.9);
				}
			}
		}
		.vip-droit{
			input[type="text"]{
				width: 140px;
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1100px);
		}
		.phone-show{
			display: none;
		}
		.menu-edit{
			border: none;
			margin: 0;
			padding: 0;
			&:before{
				display: none;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Edit.vue?4b08e67f